import { useApiTradeV1DemandSignalsList } from 'api';

export type QueryParams = {
  material_grade_id?: number;
  material_spec_id?: number;
  state?: string;
};

export const useListDemandSignals = (materialGradeId?: number, materialSpecId?: number, queryEnabled = true) => {
  const { data, refetch } = useApiTradeV1DemandSignalsList(
    {
      material_grade_id: materialGradeId || undefined,
      material_spec_id: materialSpecId || undefined,
      state: 'UNMATCHED',
    },
    {
      query: {
        enabled: queryEnabled,
        queryKey: [materialGradeId, materialSpecId],
      },
    }
  );

  return { demandSignals: data || [], refetch };
};
